import { Referensforsaljning } from '../../types/dtos/VarderingarModel';
import styles from './Referensforsaljningar.module.css';

interface ReferensforsaljningarProps {
  referensforsaljningar: Referensforsaljning[];
}

export const Referensforsaljningar = ({
  referensforsaljningar,
}: ReferensforsaljningarProps) => {
  const rows = referensforsaljningar.map((r, i) => (
    <tr key={i}>
      <td className={styles.adress}>{r.adress}</td>
      <td>{r.antalRum}</td>
      <td>{r.boarea}</td>
      <td>{r.biarea}</td>
      <td>{r.tomtarea}</td>
      <td>{r.byggar}</td>
      <td>{r.pris?.toLocaleString('sv')} kr</td>
      <td>{r.prisPerKvm?.toLocaleString('sv')} kr</td>
      <td>{r.prisIdag?.toLocaleString('sv')} kr</td>
      <td>{r.prisIdagPerKvm?.toLocaleString('sv')} kr</td>
      <td>{r.datum}</td>
    </tr>
  ));

  return (
    <table className={styles.referensforsaljningarTable}>
      <thead>
        <tr>
          <th>Adress</th>
          <th>Antal rum</th>
          <th>Boarea</th>
          <th>Biarea</th>
          <th>Tomtarea</th>
          <th>Byggår</th>
          <th>Pris</th>
          <th>Pris / m&sup2;</th>
          <th>Pris idag</th>
          <th>Pris idag / m&sup2;</th>
          <th>Datum</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};
